<template>
  <header class="ride-list__card__header">
    <span
      class="list__card__label"
      :class="`list__card__label--${statusCssClass}`"
    >
      {{ status ? $t(`${namespace}.rideList.status.${status}`) : '-' }}
    </span>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    status: {
      type: String
    }
  },
  computed: {
    statusCssClass () {
      const statusList = {
        'WAITING_DRIVERS_ANSWERS': 'info',
        'CAR_ON_THE_WAY': 'primary',
        'WAITING_FOR_PASSENGER': 'warning',
        'CAR_ARRIVED': 'success',
        'IN_PROGRESS': 'success',
        'RIDE_ENDED': 'default',
        'CANCELED_BY_DRIVER': 'error',
        'CANCELED_BY_PASSENGER': 'error',
        'COULDNT_FIND_AVAILABLE_DRIVERS': 'error',
        'DRIVERS_REJECTED': 'error'
      }

      return statusList[this.status] || 'default'
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage'
    }
  }
}
</script>

<style lang="scss" scoped>
.ride-list__card__header {
  position: relative;
}

.list__card__label {
  background-color: $gray-3;
  border-radius: 4px;
  color: $gray-8;
  font-family: 'Montserrat', sans-serif;
  font-size: 8px;
  font-weight: bold;
  line-height: normal;
  padding: 4px 8px;
  position: absolute;
  right: 20px;
  top: 20px;
  text-transform: uppercase;
  white-space: nowrap;

  &.list__card__label--info {
    background-color: #2d9dcc;
    color: #fff;
  }

  &.list__card__label--primary {
    background-color: #036dc3;
    color: #fff;
  }

  &.list__card__label--error {
    background-color: #cc2e2d;
    color: #fff;
  }

  &.list__card__label--success {
    background-color: #2dbb54;
    color: #fff;
  }

  &.list__card__label--warning {
    background-color: $secondary;
    color: #fff;
  }

  &.list__card__label--default {
    background-color: #a1a1a1;
    color: #fff;
  }
}
</style>
